import { useParams, useSearchParams } from "react-router-dom";

import { useLectureItems } from "./hooks/useLectureItems";
import { parseSearchParams } from "@/utils/helpers";

import ItemsContainer from "./components/ItemsContainer";
import SpinnerFullPage from "@/components/loadingPage/SpinnerFullPage";
import Pagination from "@/components/Pagination";
import Materials from "./components/Materials";
import usePermission from "@/hooks/usePermission";
import Header from "../components/Header";

function LecturePage() {
    const { courseId, lectureId } = useParams();
    let pagesLinks = [
        {
            name: "محتويات المحاضره",
            link: `/admin/courses/${courseId}/lectures/${lectureId}`,
        },
        { name: "الصفحة الرئيسية", link: `/` },
        {
            name: "الفصول الدراسية",
            link: `/admin/courses`,
        },
        {
            name: "المحاضرات",
            link: `/admin/courses/${courseId}/lectures`,
        },
    ];

    const [searchParams] = useSearchParams();

    const { can } = usePermission();

    const page = parseSearchParams(
        searchParams,
        "page",
        (value) => (parseInt(value, 10) < 1 ? 1 : parseInt(value, 10)),
        1
    );
    const perPage = 10;

    const { lectureItems, isPending } = useLectureItems({
        lectureId,
        courseId,
        page,
        perPage,
    });

    if (isPending) return <SpinnerFullPage />;

    const totalPages = Math.ceil(
        lectureItems?.meta?.total / lectureItems?.meta?.per_page
    );

    return (
        <>
            <Header
                pageName="محتويات المحاضره"
                pages={pagesLinks}
                className="text-2xl"
            />

            <ItemsContainer lectureItems={lectureItems} />

            <div className="flex items-center justify-center py-6">
                {totalPages > 1 && !isPending && (
                    <Pagination total={totalPages} />
                )}
            </div>
            {can("read:course:lecture:materials") && <Materials />}
        </>
    );
}

export default LecturePage;
